import { render } from "./ResultModal.vue?vue&type=template&id=fce365a4&scoped=true&ts=true"
import script from "./ResultModal.vue?vue&type=script&lang=ts"
export * from "./ResultModal.vue?vue&type=script&lang=ts"

import "./ResultModal.vue?vue&type=style&index=0&id=fce365a4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce365a4"]])

export default __exports__